const ModalContentFooter = ({ children }: { children: React.ReactNode }) => (
  <div className="ModalContent__footer">{children}</div>
);

export default ModalContentFooter;
